let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l0olp")).then(() => parcelRequire('8gjIO'));